
import Component from 'vue-class-component'
import Vue from 'vue'
import api from '@/api'

@Component
export default class TestLayoutView extends Vue {
  handleLogoClicked() {
    window.location.href =
        process.env.NODE_ENV === 'production'
            ? '/webpart/webparts/test/portal/home'
            : '/webparts/test/portal/home'
  }

  handleLogoutCliked() {
    const url = window.location.pathname
    this.$router.push({
      name: 'account-login',
      query: {
        returnUrl: encodeURIComponent(url),
      },
    })
  }
}
